import { OpenLocationCode } from "open-location-code";

import { getGoogleMapsLocale, parseLocationCoordinates } from "./googlePlaces";

const EVENT_LOCATION_MAP_ZOOM = 15;
// About 2 x 3 metres: preserve manually selected points without paid geocoding.
const COORDINATE_PLUS_CODE_LENGTH = 11;
const openLocationCode = new OpenLocationCode();

export function buildGoogleMapsEmbedUrl(
  mapQuery: string,
  languageCode?: string | null
) {
  const { language } = getGoogleMapsLocale(languageCode);
  const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;

  if (!apiKey) {
    throw new Error(
      "NEXT_PUBLIC_GOOGLE_MAPS_API_KEY is required for Maps Embed."
    );
  }

  const query = getEmbedPlaceQuery(mapQuery);
  const coordinates = parseLocationCoordinates(query);
  const q = coordinates
    ? openLocationCode.encode(
        coordinates.latitude,
        coordinates.longitude,
        COORDINATE_PLUS_CODE_LENGTH
      )
    : query;

  return `https://www.google.com/maps/embed/v1/place?${new URLSearchParams({
    key: apiKey,
    q,
    zoom: String(EVENT_LOCATION_MAP_ZOOM),
    language,
  })}`;
}

function getEmbedPlaceQuery(mapQuery: string) {
  if (!/^https?:\/\//i.test(mapQuery)) {
    return mapQuery;
  }

  const url = new URL(mapQuery);
  const placeId = url.searchParams.get("query_place_id");
  return placeId
    ? `place_id:${placeId}`
    : url.searchParams.get("query") || url.searchParams.get("q") || mapQuery;
}
